module.exports = __webpack_public_path__ + "static/media/bc.a1cab756.svg";